var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 26.8736 26.8747",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6762 6.43839C25.6637 6.95589 25.2349 7.36589 24.7174 7.35464C24.1999 7.34214 23.7899 6.91339 23.8012 6.39589L23.8524 4.13839L21.5962 4.08714C21.0787 4.07464 20.6687 3.64589 20.6799 3.12839C20.6924 2.61089 21.1212 2.20089 21.6387 2.21214L24.8337 2.28589C25.3512 2.29714 25.7612 2.72589 25.7487 3.24339L25.6762 6.43839Z",
    fill: "var(--fill-0, #ACACAC)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.72125 10.1196V25.2959C5.72125 26.1684 5.015 26.8746 4.1425 26.8746H1.57875C0.70625 26.8746 0 26.1684 0 25.2959V10.1196C0 9.24839 0.70625 8.54089 1.57875 8.54089H4.1425C5.015 8.54089 5.72125 9.24839 5.72125 10.1196ZM1.875 10.4159V24.9996H3.84625V10.4159H1.875Z",
    fill: "var(--fill-0, #ACACAC)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8228 17.8121V25.2959C19.8228 25.7146 19.6566 26.1159 19.3603 26.4121C19.0641 26.7084 18.6628 26.8746 18.2441 26.8746H15.6803C15.2616 26.8746 14.8603 26.7084 14.5641 26.4121C14.2678 26.1159 14.1016 25.7146 14.1016 25.2959V17.8121C14.1016 17.3934 14.2678 16.9921 14.5641 16.6959C14.8603 16.3996 15.2616 16.2334 15.6803 16.2334H18.2441C18.6628 16.2334 19.0641 16.3996 19.3603 16.6959C19.6566 16.9921 19.8228 17.3934 19.8228 17.8121ZM15.9766 18.1084V24.9996H17.9478V18.1084H15.9766Z",
    fill: "var(--fill-0, #ACACAC)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.772 13.966V25.296C12.772 26.1685 12.0658 26.8747 11.1933 26.8747H8.62953C7.75703 26.8747 7.05078 26.1685 7.05078 25.296V13.966C7.05078 13.5472 7.21703 13.146 7.51328 12.8497C7.80953 12.5535 8.21078 12.3872 8.62953 12.3872H11.1933C12.0658 12.3872 12.772 13.0947 12.772 13.966ZM8.92578 14.2622V24.9997H10.897V14.2622H8.92578Z",
    fill: "var(--fill-0, #ACACAC)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8736 13.966V25.296C26.8736 26.1685 26.1673 26.8747 25.2948 26.8747H22.7311C21.8586 26.8747 21.1523 26.1685 21.1523 25.296V13.966C21.1523 13.5472 21.3186 13.146 21.6148 12.8497C21.9111 12.5535 22.3123 12.3872 22.7311 12.3872H25.2948C26.1673 12.3872 26.8736 13.0947 26.8736 13.966ZM23.0273 14.2622V24.9997H24.9986V14.2622H23.0273Z",
    fill: "var(--fill-0, #ACACAC)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.50054 1.68713C1.08554 1.37713 1.00179 0.788385 1.31304 0.374635C1.62304 -0.0391149 2.21054 -0.122865 2.62554 0.187135L10.0668 5.76838H13.6005C13.8893 5.76838 14.1605 5.90089 14.338 6.12714L17.1968 9.76588L23.8218 2.85214C24.1793 2.47839 24.773 2.46589 25.1468 2.82464C25.5205 3.18214 25.533 3.77589 25.1755 4.14964L17.803 11.8421C17.6155 12.0384 17.3518 12.1434 17.0805 12.1296C16.8093 12.1171 16.5568 11.9859 16.3893 11.7721L13.1455 7.64338H9.75429C9.55179 7.64338 9.35429 7.57839 9.19179 7.45589L1.50054 1.68713Z",
    fill: "var(--fill-0, #ACACAC)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.6ba6865ed0d67d873d3079afe3945ec5.svg";
export { ForwardRef as ReactComponent };